import {T} from "inferno-i18next";

export function CharacterLimit(props: { maxCharacters: number, currentlyTyped: number }) {
	return (
		<div style={{"margin-top": "-10px"}} className="text-center w-100 position-absolute">
			<small className="rounded text-light bg-primary pr-3 pl-3">
				{props.maxCharacters - props.currentlyTyped} <T className="d-inline" i18nKey="VCC_XMSG_CHARACTERS_LEFT">x</T>
			</small>
		</div>
	);
}
